import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isActiveUrl',
    standalone: false
})
export class ActiveUrlPipe implements PipeTransform {

  transform(currentUrl: string, path: string): boolean {
    return currentUrl === path;
  }

}
